import styled from "styled-components"

const Wrapper = styled.div`
  max-width: 1100px;
  width: 100%;
  margin: 0 auto;
  padding: 0 25px;
`

export default Wrapper
